import React from "react";
import PropTypes from "prop-types";

import { Variables } from "../../styles/Variables";

import { Modal, Content, ButtonClose, Text, TextUrl } from "./StylesForgetPassword";

const ModalForgetPassword = ({ modalVisible, setModalVisible }) => {
  return modalVisible ? (
    <Modal onClick={() => setModalVisible(false)}>
      <Content onClick={(event) => event.stopPropagation()}>
        <ButtonClose onClick={() => setModalVisible(false)}>X</ButtonClose>
        <Text>
          Si desea cambiar la contraseña o no la recuerda deberá realizar la solicitud desde el correo autorizado por su
          entidad, con los siguientes datos: persona que realiza la solicitud, cargo dentro de la entidad, celular de
          contacto y causal de la solicitud, ésta al correo electrónico admon@integracionmigrante.com, la respuesta se
          enviará una vez verificada toda la información suministrada. Gracias por su atención.
        </Text>
        <TextUrl href="#">
          <h style={{ color: Variables.colorOrangeSecondary }}>www.integracion</h>
          <h style={{ color: Variables.colorBlueLight }}>migrante</h>
          <h style={{ color: Variables.colorRed }}>.com</h>
        </TextUrl>
      </Content>
    </Modal>
  ) : (
    <div />
  );
};

ModalForgetPassword.propTypes = {
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
};

export default ModalForgetPassword;
